import { ASSETS_BASE_URL } from '@bridebook/toolbox/src/buildImageUrl';

export const DISCOUNT_CODE = 'BRIDEBOOK26';
export const TICKETS_URL = `https://tickets.nationalweddingshow.co.uk/content/ticket-options?offercode=${DISCOUNT_CODE}`;
export const NWS_IMAGE = `${ASSETS_BASE_URL}/article/national-wedding-show.png`;
